import React from 'react';
import './GenerateButton.css';

export interface GenerateButtonProps {
  onClick: () => void;
  disabled?: boolean;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

const GenerateButton: React.FC<GenerateButtonProps> = ({
  onClick,
  disabled = false,
  children = 'AI Kombin Oluştur',
  style,
}) => {
  return (
    <button
      className="generate-button"
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      {children}
    </button>
  );
};

export default GenerateButton;

